export const SET_THEME = 'SET_THEME';
export const SET_AUTH = 'SET_AUTH';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ASSET = 'SET_ASSET';

export const SET_FILTER = 'SET_FILTER';
export const SET_GLOBAL_FILTER = 'SET_GLOBAL_FILTER';